import {Layout} from "../../../src/ts/layouts/Layout";

export class DistributorsList extends Layout {

    private readonly SELECTOR_COUNTRY_SELECT: string = '.distributors-list__country-select';
    private readonly SELECTOR_DISTRIBUTOR_ITEMS: string = '.distributors-list__list-item';

    private readonly SELECTOR_DISTRIBUTOR_LIST: string = '.distributors-list__list';
    private readonly SELECTOR_LIST_HEADING: string = '.distributors-list__list-headings';

    private readonly SELECTOR_FORM_BUTTON_CONTAINER: string = '.distributors-list__open-form-buttons';
    private readonly SELECTOR_FORM_BUTTON: string = '.distributors-list__open-form-button';


    public readonly STATE_ODD: string = 'distributors-list__list-item--odd';


    private $country_select: JQuery;
    private $open_form_buttons: JQuery;

    private $selected_country: string;

    constructor($elem: JQuery) {
        super($elem);
        this.$country_select = $elem.find(this.SELECTOR_COUNTRY_SELECT);
        this.$open_form_buttons = $elem.find(this.SELECTOR_FORM_BUTTON);
        this.$selected_country = this.$country_select.children("option:selected").val().toString();

        this.$country_select.on('change', (e) => this.onSelect(e));
        this.$open_form_buttons.on('click', (e) => this.onOpenFormClick(e));

        this.setDistributorVisibility();
    }

    private onOpenFormClick(event: JQuery.ClickEvent) {
        //console.log('onOpenFormClick');
        event.stopPropagation();
        event.stopImmediatePropagation();
        this.hideForms();

        let selectedCountryName: string = this.$country_select.children("option:selected").text();


        let id: string = $(event.target).attr('href');

        let $select: JQuery = $(id).find('select[name*="country"]');

        $select.val(selectedCountryName);

        $(id).show();

        this.scrollToForm(id);
        return false;
    }

    private scrollToForm(id: string) {
        const targetTop = $(id).offset().top - 24;
        $('html, body').stop().animate({scrollTop: targetTop}, {
            duration: 600,
            easing: 'easeOutExpo'
        });
    }

    private hideForms() {
        this.$open_form_buttons.each(function (index, element) {

            $($(this).attr('href')).hide();

        })
    }

    private onSelect(e: JQuery.ChangeEvent) {
        this.$selected_country = this.$country_select.children("option:selected").val().toString();
        this.setDistributorVisibility();
    }

    private setDistributorVisibility() {
        if (this.$selected_country == '') {
            this.$layout.find(this.SELECTOR_DISTRIBUTOR_ITEMS).hide();
            this.$layout.find(this.SELECTOR_LIST_HEADING).hide();
            this.$layout.find(this.SELECTOR_DISTRIBUTOR_LIST).hide();
            this.$layout.find(this.SELECTOR_FORM_BUTTON_CONTAINER).hide();
        } else {
            this.$layout.find(this.SELECTOR_LIST_HEADING).show();
            this.$layout.find(this.SELECTOR_DISTRIBUTOR_LIST).show();
            this.$layout.find(this.SELECTOR_DISTRIBUTOR_ITEMS).hide();
            this.$layout.find(this.SELECTOR_DISTRIBUTOR_ITEMS + '.' + this.$selected_country).show();
            this.$layout.find(this.SELECTOR_FORM_BUTTON_CONTAINER).show();
        }
        this.$layout.find(this.SELECTOR_DISTRIBUTOR_ITEMS).removeClass(this.STATE_ODD);
        this.$layout.find(this.SELECTOR_DISTRIBUTOR_ITEMS + ':visible').each((index, element) => {
            if (index % 2 === 0) {
                $(element).addClass(this.STATE_ODD);
            }
        });
    }
}